module.exports = __webpack_public_path__ + "static/media/BatteryGroup.4359d139.svg";